import { render, staticRenderFns } from "./DashboardPolicyCmvView.vue?vue&type=template&id=9ddd6144&"
import script from "./DashboardPolicyCmvView.vue?vue&type=script&lang=ts&"
export * from "./DashboardPolicyCmvView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports